import React from 'react'
import './style.scss'

export const Textarea = ({placeholder = "", rows=3, ...props}) => {
    return <textarea className="ldsrf-textarea" placeholder={placeholder} rows={rows} {...props}/>				
}